// A lazy scanner registers cleanup here without adding scanner code to login/upload.
let discard: (() => Promise<void>) | null = null;
export const registerLocalDocumentCleanup = (cleanup: () => Promise<void>) => {
    discard = cleanup;
};
export const discardLocalDocumentSession = async () => {
    const cleanup = discard;
    discard = null;
    await cleanup?.().catch(() => undefined);
};
